import { trackEvent } from '@99designs/tracking';
import {
    STEP_BRANDING_STAGE,
    STEP_INDUSTRY,
    STEP_LOGO,
    STEP_PRODUCT_PREFERENCES,
    STEP_PROMOTION,
} from '../constants';
import type { SelectedValues } from '../config';

const STEP_NAMES: Record<keyof SelectedValues, string> = {
    [STEP_BRANDING_STAGE]: 'branding_stage',
    [STEP_INDUSTRY]: 'industry',
    [STEP_PROMOTION]: 'promotion',
    [STEP_LOGO]: 'logo_need',
    [STEP_PRODUCT_PREFERENCES]: 'product_preferences',
};

export function stepCompleted(
    key: keyof SelectedValues,
    data: SelectedValues,
    stepNumber: number
): void {
    trackEvent('Brand Recommender Step Completed', {
        step_name: STEP_NAMES[key],
        value: data[key] || null,
        step_number: stepNumber,
    });
}

export function editLinkClicked(key: keyof SelectedValues, stepNumber: number): void {
    trackEvent('Branding Recommendation Details Edit Link Clicked', {
        step_name: STEP_NAMES[key],
        step_number: stepNumber,
    });
}

export function editAnswersClicked(): void {
    trackEvent('Edit your answers link on branding recommendation page clicked');
}
